/**
 * Calculates the Levenshtein distance between two strings.
 */
export function calculateLevenshtein(a: string, b: string): number {
  const matrix: number[][] = [];
  for (let i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  }
  for (let j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  }
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      if (b.charAt(i - 1) === a.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }
  }
  return matrix[b.length][a.length];
}

/**
 * Normalizes text by converting to lowercase, trimming whitespace,
 * stripping common articles (a, an, the) from the front,
 * and removing common punctuation.
 */
export function normalizeText(text: string): string {
  return text
    .trim()
    .toLowerCase()
    .replace(/^(a|an|the)\s+/, '')
    .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()?¿¡]/g, '')
    .replace(/\s+/g, ' '); // normalize multiple spaces to single space
}

/**
 * Matches user input against correct answer using fuzzy edit-distance (distance <= 1).
 */
export function checkAnswerMatch(input: string, answer: string): boolean {
  const normalizedInput = normalizeText(input);

  if (normalizedInput.length === 0) {
    return false;
  }

  // Handle exact match or multiple answers separated by slash
  const answers = answer.split('/').map((ans) => ans.trim());
  
  return answers.some((ans) => {
    const normalizedAns = normalizeText(ans);
    const dist = calculateLevenshtein(normalizedInput, normalizedAns);
    return dist <= 1;
  });
}
